import { render } from "./PageBarChart.vue?vue&type=template&id=1005aadc&scoped=true"
import script from "./PageBarChart.vue?vue&type=script&lang=js"
export * from "./PageBarChart.vue?vue&type=script&lang=js"

import "./PageBarChart.vue?vue&type=style&index=0&id=1005aadc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1005aadc"]])

export default __exports__